import {Box, Stack, Grid2 as Grid} from "@mui/material";
import TotalProblemPieChart from "../../../../../features/pie-chart-analysis";
import DailyStreakChartMain from "../../../../../features/streak-chart";
import Carousel from "../../../../../features/carousel";
import ProblemsetTableV2 from "../../../../../features/problemset-table-v2";
import QuestionCategoryFilterMain from "../../../../../features/problemset-table-v2/components/filter/category-filter-main";
import {PAGE_GRID_RATIO} from "../../../../../config/page-grid-ratio";
import {FilterType} from "../../../../../config/enums";
import {useProblemsetSync} from "../../../../../hooks/useProblemsetSync";

export default function Problemset() {
  const {selectedSubject, selectedChapter, handleProblemsetFilterUpdates} =
    useProblemsetSync();

  return (
    <Grid container justifyContent="center">
      <Grid size={PAGE_GRID_RATIO.leftMargin} />
      <Grid size={PAGE_GRID_RATIO.mainContent}>
        <QuestionCategoryFilterMain
          selectedCategory={selectedChapter?.[FilterType.FEATURE]}
          handleCategoryClick={featureId => {
            handleProblemsetFilterUpdates({
              [FilterType.FEATURE]: featureId,
            });
          }}
        />
        <Box height={24} />
        <ProblemsetTableV2
          subjectId={selectedSubject?.subjectId}
          chapterId={selectedChapter?.chapterId}
          {...{
            [FilterType.ATTEMPT_STATUS]:
              selectedChapter?.[FilterType.ATTEMPT_STATUS],
            [FilterType.PATTERN]: selectedChapter?.[FilterType.PATTERN],
            [FilterType.DIFFICULTY]: selectedChapter?.[FilterType.DIFFICULTY],
            [FilterType.FEATURE]: selectedChapter?.[FilterType.FEATURE],
            [FilterType.PAGE]: selectedChapter?.[FilterType.PAGE],
          }}
          handleFiltersUpdates={handleProblemsetFilterUpdates}
        />
      </Grid>
      <Grid size={PAGE_GRID_RATIO.middleMargin} />
      <Grid size={PAGE_GRID_RATIO.rightSidebar}>
        <Stack spacing={"16px"}>
          <Carousel />
          <DailyStreakChartMain />
          <TotalProblemPieChart />
        </Stack>
      </Grid>
      <Grid size={PAGE_GRID_RATIO.rightMargin} />
    </Grid>
  );
}
